import postHog from 'posthog-js';
import { debounce } from 'lodash-es';

export const trackEvent = (eventName: string, properties?: Record<string, unknown>): void => {
  postHog.capture(eventName, properties);
};

export const trackDebounced = debounce(trackEvent, 1000);

export const setPersonProperties = (properties?: Record<string, unknown>): void => {
  postHog.setPersonProperties(properties);
};

export const captureException = (error: Error, properties?: Record<string, unknown>): void => {
  postHog.captureException(error, properties);
};

export const isFeatureEnabled = (flag: string): boolean | undefined => postHog.isFeatureEnabled(flag);

export const getDistinctId = (): string => postHog.get_distinct_id();

export { postHog };
